export default __webpack_public_path__ + "static/media/logo.331b4abb.svg";